const __WEBPACK_NAMESPACE_OBJECT__ = require("live/components/lists/ui/search");